export default __webpack_public_path__ + "static/media/asesoria.804ad16c.svg";